import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentVendorBranch } from './normalize';

export const fetchShipmentVendorBranch = createProvider(api.fetchShipmentVendorBranch)
  .andThen((res) => normalizeShipmentVendorBranch(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
